import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { X, Loader2, KeyRound } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ChangePasswordDialog = ({ onClose }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 8) return setError("New password must be at least 8 characters.");
    if (next !== confirm) return setError("Passwords do not match.");
    setSaving(true);
    try {
      await axios.post(
        `${API}/auth/change-password`,
        { current_password: current, new_password: next },
        { withCredentials: true }
      );
      toast.success("Password changed successfully");
      onClose();
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Could not change password.");
    } finally {
      setSaving(false);
    }
  };

  const input = "w-full bg-[#F8F4EC] border border-[rgba(58,42,37,0.15)] rounded-lg px-4 py-2.5 text-sm text-[#2B1F1B] placeholder:text-[#9A8D85] focus:outline-none focus:border-[#3A2A25] transition-colors duration-300";

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-[#241813]/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-sm bg-[#FFFDF9] rounded-2xl border border-[rgba(58,42,37,0.1)] shadow-[0_30px_60px_rgba(58,42,37,0.2)] p-8" data-testid="change-password-dialog">
        <div className="flex items-center justify-between mb-6">
          <h3 className="font-serif-display text-2xl text-[#2B1F1B]">Change Password</h3>
          <button onClick={onClose} className="p-2 text-[#756A64] hover:text-[#3A2A25] transition-colors duration-300" data-testid="change-password-close">
            <X size={18} />
          </button>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} placeholder="Current password" required className={input} data-testid="current-password-input" />
          <input type="password" value={next} onChange={(e) => setNext(e.target.value)} placeholder="New password (min. 8 characters)" required className={input} data-testid="new-password-input" />
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm new password" required className={input} data-testid="confirm-password-input" />
          {error && <p className="text-xs text-[#C62828]" data-testid="change-password-error">{error}</p>}
          <button
            type="submit"
            disabled={saving}
            className="w-full px-8 py-3.5 bg-[#3A2A25] text-white text-xs font-semibold uppercase tracking-[0.2em] rounded-full hover:bg-[#55423A] transition-colors duration-300 disabled:opacity-50 flex items-center justify-center gap-2"
            data-testid="change-password-submit"
          >
            {saving ? <Loader2 size={14} className="animate-spin" /> : <KeyRound size={14} />}
            Update Password
          </button>
        </form>
      </div>
    </div>
  );
};
